import * as zoid from 'zoid/dist/zoid.frameworks.frame.min'

const createZoidChild = (params) => {
    zoid.create(params)
}

export default createZoidChild
